var map = {
	"./en-US": 9551,
	"./en-US.js": 9551,
	"./zh-CN": 8529,
	"./zh-CN.js": 8529
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1689;
module.exports = webpackAsyncContext;